<template>
    <b-modal
        :id="`modal-add-categories-products`"
        ref="modal"
        :title="$t('add')"
        size="lg"
        static
        centered
        hide-footer
    >

        <FormCategoryProductTreeSelect :group-id="groupId" :disabled-nodes="usedIds" :disabled="parentComponent.loading" @added="handleAdded" />
    </b-modal>
</template>



<script>
    import FormCategoryProductTreeSelect from '@/components/common/FormCategoryProductTreeSelect.vue';

    export default {
        name: 'ModalAddCategoriesProducts',
        components: {
            FormCategoryProductTreeSelect,
        },
        inject: {
            parentComponent: {
                default: null,
            },
        },
        data() {
            return {};
        },
        computed: {
            groupId() {
                return this.parentComponent.id;
            },
            usedIds() {
                const products = this.parentComponent.item?.products.map(item => item.id) || [];
                const categories = this.parentComponent.item?.categories.map(item => item.id) || [];
                return [...products, ...categories];
            },
        },
        methods: {
            handleAdded(node) {
                if (node.isBranch) this.$toastr.success(this.$t('addedCategoryToGroup'));
                if (node.isLeaf) this.$toastr.success(this.$t('addedProductToGroup'));
                this.parentComponent.fetchData();
            },
        },
    };
</script>
